module.exports = numeral;


//////////////////
// WEBPACK FOOTER
// external "numeral"
// module id = u2Mx
// module chunks = 2 3 4 5 6 8 9 11